import { Link } from "react-router-dom";
import { CalendarCheck, ArrowRight, ShieldCheck, Cog, Battery, Droplet, Circle } from "lucide-react";

const AREAS = [
  { i: CalendarCheck, t: "Periodic Forklift Servicing" },
  { i: Cog, t: "Engine & Transmission Service" },
  { i: ShieldCheck, t: "Safety Inspections" },
  { i: Cog, t: "Mast & Chain Inspection" },
  { i: ShieldCheck, t: "Brake Inspection" },
  { i: Droplet, t: "Hydraulic System Inspection" },
  { i: Battery, t: "Battery & Charging Inspection" },
  { i: Droplet, t: "Lubrication" },
  { i: Circle, t: "Tyres & Wheels" },
  { i: Droplet, t: "Fluid Levels & Leak Inspection" },
];

const PLANS = [
  { t: "Single Forklift", d: "For businesses operating one or two machines.", cta: "Request Maintenance Plan" },
  { t: "Fleet Maintenance", d: "For companies operating multiple forklifts. Scheduled visits, preventative servicing, maintenance reminders, fleet records and inspection reporting.", cta: "Request Fleet Quote", featured: true },
  { t: "Custom Program", d: "For businesses requiring service based on operating hours, working conditions or internal maintenance schedules.", cta: "Discuss Your Fleet" },
];

export default function Maintenance() {
  return (
    <div>
      <section className="bg-[#111111] text-white">
        <div className="max-w-7xl mx-auto px-6 py-20 ff-diagonal-bg">
          <div className="text-xs uppercase tracking-widest text-[#D71920] font-bold">Preventative maintenance</div>
          <h1 className="font-display text-5xl md:text-7xl uppercase mt-3">Reduce downtime before it becomes a problem</h1>
          <p className="mt-5 max-w-3xl text-white/75 text-lg">Forklifts operate in demanding environments. Scheduled servicing can help identify developing problems before they cause expensive downtime.</p>
          <Link to="/contact?reason=Maintenance" className="ff-btn-primary mt-8" data-testid="maint-hero-cta"><CalendarCheck className="w-4 h-4" /> Request a Maintenance Plan</Link>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-6 py-16">
        <h2 className="ff-accent-heading font-display text-4xl uppercase mb-8">Inspection areas</h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#e5e5e5] border border-[#e5e5e5]">
          {AREAS.map(({ i: I, t }) => (
            <div key={t} className="bg-white p-6 flex items-center gap-4">
              <I className="w-6 h-6 text-[#D71920]" />
              <div className="font-display text-xl uppercase">{t}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-[#f4f4f4] py-16">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="ff-accent-heading font-display text-4xl uppercase mb-8">Maintenance solutions</h2>
          <div className="grid md:grid-cols-3 gap-5">
            {PLANS.map(p => (
              <div key={p.t} className={`ff-card p-8 ${p.featured ? "border-[#D71920] border-2" : ""}`}>
                {p.featured && <div className="ff-badge-avail mb-3 inline-block">Most popular</div>}
                <h3 className="font-display text-3xl uppercase">{p.t}</h3>
                <p className="text-sm text-[#555] mt-3">{p.d}</p>
                <Link to={`/contact?reason=Maintenance&plan=${encodeURIComponent(p.t)}`} className="mt-5 inline-flex items-center gap-1 text-xs uppercase tracking-widest font-bold text-[#D71920]" data-testid={`plan-${p.t}`}>
                  {p.cta} <ArrowRight className="w-3.5 h-3.5" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
